import TableCustom from '../../../components/table-custom.component';
import {
	columnsSuspensionsRoutine,
	columnsSuspensionsSupervisionRoutine,
} from '../utils/columns-suspensions.utils';
import { useGetFindingsTable } from './hooks/useGetFindingsTable';
import { Image } from '@mui/icons-material';
import { useDownloadImageZip } from './hooks/useDownloadImageZip';

interface IFindings {
	isSupervisionRoutine: boolean;
	isFindings: boolean;
}

export const Suspensions = ({ isSupervisionRoutine, isFindings }: IFindings) => {
	const { handleDownloadZip } = useDownloadImageZip();
	const { data, idRoutine, _id, idRoutineParams, idProject, idProjectParams, setData } =
		useGetFindingsTable({
			isSupervisionRoutine,
			isFindings,
		});

	return (
		<TableCustom
			titleHeader="Suspensiones"
			columns={
				isSupervisionRoutine
					? columnsSuspensionsSupervisionRoutine
					: columnsSuspensionsRoutine
			}
			data={data}
			setData={setData}
			showPagination
			showLimitPerPage
			showSearch={false}
			buttons={
				data.rows.length !== 0
					? [
							{
								icon: Image,
								label: 'Descargar suspensiones',
								id: 'descarga-suspensiones',
								execute: () => {
									handleDownloadZip(
										'suspension-files',
										idRoutineParams || idRoutine,
										_id || idProjectParams || idProject,
										data.pagination,
										data.rowsPerPage || '0'
									);
								},
								type: 'blue',
								width: 220,
							},
					  ]
					: []
			}
		/>
	);
};
